module.exports = __webpack_public_path__ + "img/LogoDashboard-15.ef9fe5e9.svg";